// Write card field rows, array-of-objects sections, segment audience
// preview and shared small buttons (FieldGrid / SegmentAudiencePreview)
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisCardFields = `
/* Write card field rows */
.pr-wcard { margin-left: 44px; }
.pr-wcard-fields {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 6px 18px;
  margin: 0;
  padding: 10px 0 2px;
  border-top: 1px dotted var(--pr-border);
  font-size: 13px;
}
.pr-wcard-fields dt {
  font-family: var(--pr-font-mono);
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pr-ink-4);
  font-weight: 500;
  padding-top: 6px;
}
.pr-wcard-fields dd {
  margin: 0;
  color: var(--pr-ink);
  display: flex; align-items: center; gap: 6px;
}

/* Array-of-objects fields (e.g. order rows): a titled section whose items are
   indented (padding, not a left-border accent) and separated by a thin divider. */
.pr-objarray {
  grid-column: 1 / -1;
  padding-top: 8px;
}
.pr-objarray-title {
  font-family: var(--pr-font-mono);
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pr-ink-4);
  font-weight: 500;
  margin-bottom: 6px;
}
.pr-objarray-item {
  padding: 7px 0 7px 14px;
  border-top: 1px dotted var(--pr-border);
}
.pr-objarray-item:first-of-type {
  border-top: none;
  padding-top: 0;
}
.pr-objarray-num {
  font-family: var(--pr-font-mono);
  font-size: 10px;
  color: var(--pr-ink-4);
  font-weight: 600;
  margin-bottom: 3px;
}
.pr-objarray-fields {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 3px 14px;
  margin: 0;
}
.pr-objarray-fields dt {
  font-family: var(--pr-font-mono);
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pr-ink-4);
  font-weight: 500;
  padding-top: 1px;
}
.pr-objarray-fields dd {
  margin: 0;
  color: var(--pr-ink);
}

/* Segment draft preview (WriteCard body for entity=segment): audience-size
   banner + ALL / ANY / exclude criteria groups. */
.pr-segment-preview {
  padding: 10px 0 2px;
  border-top: 1px dotted var(--pr-border);
  font-size: 13px;
}
.pr-segment-audience-size {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  background: var(--pr-surface);
  border: 1px solid var(--pr-hairline);
  color: var(--pr-ink-3);
  font-size: 12.5px;
}
.pr-segment-audience-size strong {
  color: var(--pr-ink);
  font-weight: 600;
}
.pr-segment-group {
  padding-top: 8px;
}
.pr-segment-group:first-child {
  padding-top: 0;
}
.pr-segment-criterion {
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 0 4px 14px;
  border-top: 1px dotted var(--pr-border);
}
.pr-segment-criterion:first-of-type {
  border-top: none;
}
.pr-segment-criterion-field {
  color: var(--pr-ink-3);
  font-weight: 500;
}
.pr-segment-criterion-op {
  color: var(--pr-ink-4);
}
.pr-segment-criterion-value {
  color: var(--pr-ink);
}

/* Shared small buttons */
.pr-btn {
  font-family: var(--pr-font-ui);
  font-size: 12.5px; font-weight: 500;
  padding: 7px 14px;
  border-radius: 3px;
  cursor: pointer;
  line-height: 1.2;
  transition: background 120ms ease, color 120ms ease, border-color 120ms ease;
  border: 1px solid transparent;
}
.pr-btn:disabled { opacity: 0.45; cursor: not-allowed; }
.pr-btn-ghost {
  background: transparent;
  border-color: var(--pr-hairline);
  color: var(--pr-ink-3);
}
.pr-btn-ghost:hover:not(:disabled) { color: var(--pr-ink); border-color: var(--pr-border-2); }
.pr-btn-primary {
  background: var(--pr-ink);
  color: var(--pr-surface);
  border-color: var(--pr-ink);
}
.pr-btn-primary:hover:not(:disabled) { background: var(--pr-ink-2); border-color: var(--pr-ink-2); }
.pr-btn-primary.create { background: oklch(0.42 0.12 155); border-color: oklch(0.42 0.12 155); }
.pr-btn-primary.create:hover:not(:disabled) { background: oklch(0.37 0.13 155); border-color: oklch(0.37 0.13 155); }
.pr-btn-primary.delete { background: oklch(0.50 0.17 25); border-color: oklch(0.50 0.17 25); }
.pr-btn-primary.delete:hover:not(:disabled) { background: oklch(0.44 0.18 25); border-color: oklch(0.44 0.18 25); }
`;
